import { useAuthCtx } from '@/app/context/auth/authContextController/AuthContextController';
import { jwtDecode } from 'jwt-decode';
import { useMemo } from 'react';

type JWTResponse = {
  RoleId: string;
  LoginId: string;
  TraceId: string;
  UserId: string;
  UserName: string;
};

function getJwtFromAccessToken(accessToken?: string) {
  if (!accessToken) return null;

  const token = accessToken.startsWith('Bearer ') ? accessToken.slice(7) : accessToken;

  if (token.split('.').length !== 3) return null;

  return token;
}

function safeDecode<T>(accessToken?: string | null): T | null {
  const token = getJwtFromAccessToken(accessToken ?? '');
  if (!token) return null;

  try {
    return jwtDecode<T>(token);
  } catch {
    return null;
  }
}

export function useRoleId() {
  const auth = useAuthCtx();

  return useMemo(() => {
    const decoded = safeDecode<JWTResponse>(auth?.accessToken);
    return decoded?.RoleId ?? null;
  }, [auth?.accessToken]);
}
